import DialogButton, { type DialogButtonProps } from './DialogButton';
import { FormattedMessage } from 'react-intl';

const DialogCreateButton = ({ children, ...props }: DialogButtonProps) => (
  <DialogButton color="primary" {...props}>
    {children ?? <FormattedMessage id="dialogs.actions.create" />}
  </DialogButton>
);

export default DialogCreateButton;
